import React from "react";
import cn from "classnames";
import s from "../DisclaimerBlock.module.scss";
import b from "../../../ui/Button/Button.module.scss";
import type { RichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";
import BlockIntro from "../../Common/BlockIntro";

type Props = {
  setShowContent: (show: boolean) => void;
  setDisclaimerState: (state: string) => void;
  disclaimerAuthorizedContentDescription: RichTextContent;
  disclaimerAuthorizedContentTitle: string;
  disclaimerSecondPageButtonText: string;
  disclaimerSecondPageSecondaryButtonText: string;
};

const AuthorizedContent = ({
  disclaimerAuthorizedContentDescription,
  disclaimerAuthorizedContentTitle,
  disclaimerSecondPageButtonText,
  disclaimerSecondPageSecondaryButtonText,
  setShowContent,
  setDisclaimerState,
}: Props) => {
  const handleConfirmButton = () => {
    setShowContent(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className={s.authorizedContent}>
      <BlockIntro
        title={disclaimerAuthorizedContentTitle}
        description={disclaimerAuthorizedContentDescription}
        width={"full"}
        alignment={"alignLeft"}
      />
      <div className={s.buttonsContainer}>
        <button className={cn(b.button, b.cta)} onClick={handleConfirmButton}>
          <span>{disclaimerSecondPageButtonText}</span>
        </button>
        <button
          className={cn(b.button, b.cta)}
          onClick={() => setDisclaimerState("restrictedAccess")}
        >
          <span>{disclaimerSecondPageSecondaryButtonText}</span>
        </button>
      </div>
    </div>
  );
};

export default AuthorizedContent;
